module.exports = __webpack_public_path__ + "img/help1_msdblayout.1ad8f76a.png";